'use client';
interface CategoryFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryFilter({
  categories,
  activeCategory,
  onCategoryChange,
}: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-3 mb-12">
      {categories.map((category) => (
        <button
          key={`category_${category.toLowerCase().replace(/\s+/g, '_')}`}
          onClick={() => onCategoryChange(category)}
          className={`px-6 py-3 rounded-lg font-medium text-sm transition-all duration-300 ${
            activeCategory === category
              ? 'bg-white text-background shadow-lg'
              : 'glass-panel text-white hover:bg-white/10'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
}
